import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=4dd60722&scoped=true&"
import script from "./CouponManagement.vue?vue&type=script&lang=js&"
export * from "./CouponManagement.vue?vue&type=script&lang=js&"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=4dd60722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd60722",
  null
  
)

export default component.exports